import { SdbProject, SdbProjectWithPosition } from "@custom-types/project-types";

/**
 * Type guard to check if a SdbProject entity has defined position
 * and can be treated as SdbProjectWithPosition.
 * @param project - The SdbProject entity to check
 * @returns True if the project has a defined position, false otherwise
 */
export function isSdbProjectWithPosition(
  project: SdbProject
): project is SdbProjectWithPosition {
  return (
    "position" in project &&
    typeof project.position === "object" &&
    project.position !== null &&
    "lat" in project.position &&
    typeof project.position.lat === "number" &&
    "long" in project.position &&
    typeof project.position.long === "number"
  );
}
